var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-checkbox-group', {
    class: {
      'no-event': _vm.readonly
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: _vm.multipleValue,
      callback: function callback($$v) {
        _vm.multipleValue = $$v;
      },
      expression: "multipleValue"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(" " + _vm._s(item.title) + " "), _c('el-row', [_c('el-col', {
      attrs: {
        "lg": 24,
        "xl": 24
      }
    }, _vm._l(_vm.otherValue, function (sub, index) {
      return _c('p', {
        key: 'sub' + index
      }, [item.other && item.other.type === 'textarea' && sub['k'] == item.value && _vm.multipleValue.includes(sub['k']) ? _c('el-input', {
        directives: [{
          name: "regexFilter",
          rawName: "v-regexFilter",
          value: _vm.halfWidthRegex,
          expression: "halfWidthRegex"
        }],
        attrs: {
          "type": "textarea",
          "placeholder": "please input..",
          "rows": 2,
          "autosize": {
            minRows: 2
          },
          "readonly": _vm.readonly
        },
        on: {
          "input": _vm.handleInput
        },
        model: {
          value: _vm.otherValue[index]['v'],
          callback: function callback($$v) {
            _vm.$set(_vm.otherValue[index], 'v', $$v);
          },
          expression: "otherValue[index]['v']"
        }
      }) : _vm._e()], 1);
    }), 0)], 1)], 1);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }